import { ids } from '@icarros/theme-react';
import styled, { css, keyframes } from 'styled-components';
import { gridPattern } from './gridStyles';

interface SideContainerWrapperProps {
  isOpen: boolean;
  isTransition: boolean;
  showOnMobile?: boolean;
}

interface ContentWrapperProps {
  showOnMobile?: boolean;
}

const SlideIn = keyframes`
  from {
    left: 100%
  }
  to {
    left: 0
  }
`;

const SlideOverlayIn = keyframes`
  from {
    width: 0
  }
  to {
    width: 100vw
  }
`;

const SlideOut = keyframes`
  from {
    left: 0
  }
  to {
    left: 100%
  }
`;

const SlideOverlayOut = keyframes`
  from {
    width: 100vw
  }
  to {
    width: 0
  }
`;

export const SideContainerWrapper = styled.div<SideContainerWrapperProps>`
  padding-top: 40px;

  ${({ isOpen }) =>
    !isOpen &&
    css`
      min-height: 80vh;
      height: fit-content;
    `}

  ${({ isTransition, isOpen }) =>
    !isTransition &&
    !isOpen &&
    css`
      display: none;
      visibility: hidden;
    `}



  > button {
    flex-direction: row-reverse;
    padding-left: 0;
  }

  @media (min-width: 1366px) {
    display: block;
    visibility: visible;
    padding-block-start: 20px !important;
    padding-inline-start: 32px !important;
    width: 600px;
    position: sticky;
    top: 65px;
    align-self: flex-start;
    min-height: 100vh;
    max-height: max-content;
    ${({ isOpen }) =>
      isOpen &&
      css`
        top: 0px;
        position: relative !important;
        &::after {
          content: '';
          width: 100vw;
          height: 100%;
          background: rgba(0, 0, 0, 0.5);
          position: absolute;
          top: 0;
          left: -100vw;
          z-index: var(--overlay-z);
          animation: ${SlideOverlayIn} 0.3s forwards;
        }
      `}

    ${({ isTransition }) =>
      isTransition &&
      css`
        &::after {
          animation: ${SlideOverlayOut} 0.3s forwards;
        }
      `}
  }

  @media (max-width: 1365px) {
    ${({ isOpen }) =>
      isOpen &&
      css`
        position: absolute;
        inset: 0;
        display: block;
        visibility: visible;
        min-height: 100vh;
        max-height: max-content;
        width: 100%;
        background-color: white;
        animation: ${SlideIn} 0.3s forwards;
      `}

    ${({ isTransition }) =>
      isTransition &&
      css`
        overflow: hidden;
        animation: ${SlideOut} 0.3s forwards;
      `}


    ${({ isTransition, isOpen }) =>
      !isTransition &&
      isOpen &&
      css`
        display: block;
        visibility: visible;
        position: static;
      `}


  ${({ showOnMobile }) =>
      showOnMobile &&
      css`
        display: block;
        visibility: visible;
        margin-top: 60px;
        margin-bottom: 120px;
        border-top: 1px solid ${ids.color.border.ids_color_border_soft};
        @media (min-width: 1366px) {
          margin-top: 0;
          border-top: none;
        }
      `}
  }
`;

export const ContentWrapper = styled.div<ContentWrapperProps>`
  ${gridPattern}
  position: relative;

  @media (min-width: 1366px) {
    display: flex;
    gap: 0;
  }
`;
